import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const ADAPTER_LOCALES = {
  en: 'en',
  'en-US': 'en',
  'en-GB': 'en-gb',
  es: 'es',
  'fr-FR': 'fr',
  pt: 'pt',
  'pt-PT': 'pt',
  'pt-BR': 'pt-br',
} as const;

const isAdapterLocale = (
  locale: string,
): locale is keyof typeof ADAPTER_LOCALES => {
  const isSupportedLocale = locale in ADAPTER_LOCALES;
  if (!isSupportedLocale) {
    Sentry.captureMessage(`Unsupported locale detected: ${locale}`);
  }

  return isSupportedLocale;
};

export type TAdapterLocale =
  (typeof ADAPTER_LOCALES)[keyof typeof ADAPTER_LOCALES];

export const NAVIGATOR_LOCALE: TAdapterLocale = isAdapterLocale(
  navigator.language,
)
  ? ADAPTER_LOCALES[navigator.language]
  : ADAPTER_LOCALES.en;

dayjs.locale(NAVIGATOR_LOCALE);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);

// Timezones
dayjs.extend(utc);
dayjs.extend(timezone);

export const LOCALE_FORMAT = dayjs.localeData().longDateFormat('L');
